import styled from "@emotion/styled";
import { transparentWhite } from "@stepfinance/react";
import React, { useEffect } from "react";

import { ReactComponent as StakingIcon } from "../../../assets/dashboard-staking.svg";
import { useLanguageContext } from "../../../contexts/language/language";
import { useStakingContext } from "../../../contexts/staking";
import type { CollapseControlProps } from "../../../hooks/home/useCollapseControl";
import { ChevronCollapse } from "../ChevronCollapse/ChevronCollapse";
import { NFTStaking } from "./NFTStaking";
import { SingleAssetStaking } from "./SingleAssetStaking";

export const Staking: React.FC<CollapseControlProps> = ({ activePanels, getPanelKey, onPanelClick }) => {
  const { stakingPositions, nftPositions, totalValue, setStakingBalance } = useStakingContext();

  const {
    currentLanguageData: { common },
  } = useLanguageContext();

  useEffect(() => {
    setStakingBalance(totalValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalValue]);
  return (
    <>
      {stakingPositions.length > 0 || nftPositions.length > 0 ? (
        <StakingContainer>
          <ChevronCollapse
            title={common.staking}
            value={totalValue}
            TitleIcon={StakingIcon}
            activePanels={activePanels}
            panelKey={getPanelKey("Staking")}
            onChange={onPanelClick}
          >
            <>
              <StakingPositionsContainer>
                <SingleAssetStaking stakingPositions={stakingPositions} />
                <NFTStaking stakingPositions={nftPositions} />
              </StakingPositionsContainer>
            </>
          </ChevronCollapse>
        </StakingContainer>
      ) : null}
    </>
  );
};

export const PendingText = styled.span`
  font-weight: 700;
  color: ${transparentWhite};
`;

const StakingContainer = styled.div`
  margin-top: 20px;
`;

const StakingPositionsContainer = styled.div`
  > * {
    margin-bottom: 20px;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;
